export default "__VITE_ASSET__5uP_bdhv__"